export const APP_PLATFORM__MOBILE = 'mobile';
export const APP_PLATFORM__DESKTOP = 'desktop';



// WEBPACK FOOTER //
// ./src/core/constants/index.js